import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './search-results-main-display-item.component.scss';
var SearchResultsMainDisplayItem = /** @class */ (function (_super) {
    tslib_1.__extends(SearchResultsMainDisplayItem, _super);
    function SearchResultsMainDisplayItem(element) {
        return _super.call(this, element) || this;
    }
    SearchResultsMainDisplayItem.prototype.init = function () {
    };
    SearchResultsMainDisplayItem.prototype.bindEvents = function () {
    };
    return SearchResultsMainDisplayItem;
}(Base));
export { SearchResultsMainDisplayItem };



//////////////////
// WEBPACK FOOTER
// ./components/search-results-main-display-item/search-results-main-display-item.component.ts
// module id = 681
// module chunks = 0